import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ImageBrokenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ImageBroken",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M6.353 10.76a1.78 1.78 0 0 0-1.778 1.778c0 .98.798 1.778 1.778 1.778a1.78 1.78 0 0 0 1.778-1.778 1.78 1.78 0 0 0-1.778-1.779M31.665 30.048 1.95.335A1.143 1.143 0 0 0 .334 1.95l29.714 29.714a1.143 1.143 0 0 0 1.617-1.617M4.91 22.498c.224.224.516.335.809.335s.585-.111.808-.334l3.127-3.127c.48-.482 1.32-.481 1.8 0l1.401 1.402a1.143 1.143 0 1 0 1.617-1.616l-1.402-1.402c-1.343-1.346-3.687-1.345-5.032 0l-3.127 3.126a1.143 1.143 0 0 0 0 1.616"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.429 25.143h-16c-.63 0-1.143-.513-1.143-1.144V8A1.143 1.143 0 1 0 0 8v16a3.433 3.433 0 0 0 3.429 3.429h16a1.143 1.143 0 0 0 0-2.285M12.57 6.857h16c.631 0 1.144.512 1.144 1.143v16a1.143 1.143 0 0 0 2.285 0V8c0-1.89-1.538-3.43-3.429-3.43h-16a1.143 1.143 0 1 0 0 2.287"
    }), /*#__PURE__*/_jsx("path", {
      d: "m20.379 12.157-1.202 1.2a1.143 1.143 0 0 0 1.615 1.618l1.16-1.16c.547-.493 1.2-.488 1.7.014l1.836 1.836a1.14 1.14 0 0 0 1.617 0 1.143 1.143 0 0 0 0-1.616l-1.835-1.836c-1.36-1.36-3.397-1.4-4.891-.056"
    })]
  }));
};
ImageBrokenIcon.displayName = 'ImageBrokenIcon';